import React, { Component } from 'react';


import Modal from "./Modal/containers/ModalContainer";
import Loader from "./Modal/containers/LoaderContainer";

import Routes from './routes/routes';

import './style/clientStyle.css';
import './gridStyle.css';


class App extends Component {
  render() {
    return (
      <>
        <Routes />
        <Modal />
        <Loader />
      </>
    );
  }
}

export default App;
